module.exports = __webpack_public_path__ + "Lato-BoldItalic.87e962f245a30e5b1662.eot";


//////////////////
// WEBPACK FOOTER
// /home/alee/projects/egis-rse-dev/src/assets/fonts/Lato-BoldItalic.eot
// module id = ../../../../../src/assets/fonts/Lato-BoldItalic.eot
// module chunks = styles